export default "__VITE_ASSET__9N80a9dw__"